<template>
  <div class="resetPwd-container">
    <div class="resetPwd-container-wrap">
      <div class="logo-wrap">
        <img src="../../assets/img/Logo_CertiLife.svg" />
      </div>
      <div class="desc-wrap">
        카톡에 저장하는 디지털 의료기기 인증서
      </div>
      <div class="resetPwd-area">
        <div class="title-wrap">
          <h4>
            새로운 비밀번호를 <br/>
            입력해주세요.
          </h4>
        </div>
        <PasswordInputAndConfirm @pwd-changed="resetPwdForm.password.pwdChangedListener"
                                 @pwd-correspond="resetPwdForm.password.correspond"
        />
        <div class="buttons-container">
          <a-button class="ok-btn" @click="resetBtn.click" :disabled="checkDisable">
            완료
          </a-button>
          <a-button class="cancel-btn" @click="uiHandler.signOut">
            뒤로 가기
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/tokenStore';
import {RouterEnum} from "@/enums/router.enums";
import PasswordInputAndConfirm from "@/views/Signin/components/PasswordInputAndConfirm.vue";
import {logging, oneBtnDialog, twoBtnDialog} from "@/utils/utils";
import axios from "axios";
import Footer from "@/views/Signin/components/Footer.vue";

export default {
  name: 'ResetPwd',
  components: {Footer, PasswordInputAndConfirm},
  computed: {
    checkDisable() {
      if (this.resetPwdForm.password.paramVal === '') {
        return true
      } else if (this.resetPwdForm.password.confirm.paramVal === '') {
        return true
      } else if (this.resetPwdForm.password.paramVal !== this.resetPwdForm.password.confirm.paramVal) {
        return true
      } else {
        return false
      }
    }
  },
  data() {
    const page = this;
    return {
      uiHandler: page.ui(),
      apiHandler: page.api(),
      resetPwdForm: {
        id: sessionStorage.getItem('username'),
        password: {
          displayVal: '',
          paramVal: '',
          confirm: {
            displayVal: '',
            paramVal: '',
          },
          isCorrectRule: false,
          bindChildParam: (childPassParam) => {
            logging().exceptProd("[초기 아이디, 비번 설정]-[비밀번호 입력값]===>", {
              비밀번호_입력값: childPassParam.paramVal, 비밀번호_마스킹값: childPassParam.displayVal,
              비밀번호_확인_입력값: childPassParam.confirmParamVal, 비밀번호_확인_마스킹값: childPassParam.confirmDisplayVal,
            })
            this.resetPwdForm.password.displayVal = childPassParam.displayVal;
            this.resetPwdForm.password.paramVal = childPassParam.paramVal;
            this.resetPwdForm.password.confirm.displayVal = childPassParam.confirmDisplayVal;
            this.resetPwdForm.password.confirm.paramVal = childPassParam.confirmParamVal;
            this.resetPwdForm.password.isCorrectRule = childPassParam.paramVal;
          },
          isEmpty: () => {
            return this.resetPwdForm.password.paramVal === "" || this.resetPwdForm.password.confirm.paramVal === "";
          },
          correspond: (isCorrespond) => {
            if (!this.resetPwdForm.password.paramVal && !this.resetPwdForm.password.confirm.paramVal) {
              this.resetBtn.able = false;
              return
            }
            this.resetBtn.able = isCorrespond;
          },
          pwdChangedListener: (childPassParam) => {
            logging().exceptProd('===>', childPassParam);
            this.resetPwdForm.password.bindChildParam(childPassParam)
          },
        },
        // 첫 로그인 강제 변경: 초기 비밀번호 = 아이디(signInMixin 이 username 을 넘김)
        translateParam: () => {
          return {
            currentPassword: this.resetPwdForm.id,
            newPassword: this.resetPwdForm.password.paramVal,
          }
        }
      },
      resetBtn: {
        able: false,
        click: async () => {
          const {isSuccess} = await this.apiHandler.resetPwd();
          if (isSuccess) {
            // 로그인 토큰은 그대로 씀. 토큰·새 비밀번호를 따로 저장하지 않음(REQ-SEC-012)
            sessionStorage.removeItem('username');
            this.$router.push({name: 'Dashboard'}).then(() => window.location.reload())
          }
        }
      }
    }
  },
  methods: {
    ui() {
      return {
        signOut: async () => {
          const confirmResult = await twoBtnDialog('안내', '정말 페이지에서 나가시겠습니까?', this.$i18n.t('common_confirm'));
          if(confirmResult) {
            await this.$store.dispatch('clearLocalStorage');
            window.checkIsLoggedIn({
              isLoggedIn:false,
              accessToken:null,
              refreshToken:null,
            });
            this.$router.push('/signin');
            document.querySelector('body').classList.remove('modal-open');
          }
        }
      }
    },
    api() {
      return {
        resetPwd: async () => {
          try {
            // 재설정 토큰 경로(/accounts/reset/password)를 로그인 토큰으로 쓰던 우회 대신 기존 비밀번호 변경 API(D-39)
            const response = await axios.post(`${process.env.VUE_APP_SERVERURL}/companies/changePassword`, this.resetPwdForm.translateParam(), {headers: {Authorization: `Bearer ${getAccessToken()}`}})
            if (response.status !== 200 && response.status !== 201) {
              return {
                isSuccess: false,
                response
              };
            } else {
              return {
                isSuccess: true,
                response
              };
            }
          } catch (error) {
            await oneBtnDialog('비밀번호 변경 실패', error.response?.data?.message || '비밀번호 변경에 실패했습니다.');

            return {
              isSuccess: false,
              response: error.response
            };
          }
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/reset-pwd.scss';
</style>